import React from 'react';
export function usePermission(permissions) {
    var userCan = React.useCallback(function (permission) {
        return (permissions === null || permissions === void 0 ? void 0 : permissions.includes(permission)) || false;
    }, [permissions]);
    return { userCan: userCan };
}
